import Interpolators from "./Interpolators";
import ConstantConverter from "../Parser/ConstantConverter";
import Accessor from "../Accessor/Accessor";
export default class Animator {
    constructor(tf, animationKey, _buffers) {
        this.tf = tf;
        this.animationKey = animationKey;
        this._buffers = _buffers;
        this.accessors = {};
        this.timeLength = 0;
        this.targetNodes = [];
        this._animationData = tf.animations[animationKey];
        const accessors = {};
        for (let key in this._animationData.parameters) {
            const ac = tf.accessors[this._animationData.parameters[key]];
            this.accessors[key] = new Accessor(_buffers[ac.bufferView], ac.count, ac.componentType, ConstantConverter.asVectorSize(ac.type), ac.byteOffset || 0, ac.byteStride || 0);
        }
        for (let channel of this._animationData.channels) {
            const sampler = this._animationData.samplers[channel.sampler];
            const input = this.accessors[sampler.input];
            this.timeLength = Math.max(this.timeLength, input.getByIndex(input.count - 1)[0]);
            this.targetNodes.push(channel.target.id);
            if (channel.target.path === "rotation" && this._animationData.samplers[channel.sampler].interpolation === "LINEAR") {
                this._animationData.samplers[channel.sampler].interpolation = "SPHERICAL";
            }
        }
    }
    processCurrentFrame(time, processor) {
        for (let i = 0; i < this._animationData.channels.length; i++) {
            const channel = this._animationData.channels[i];
            const v = this._getBySampler(channel.sampler, time);
            processor(channel.target.id, channel.target.path, v);
        }
    }
    _getBySampler(samplerName, t) {
        const sampler = this._animationData.samplers[samplerName];
        const inputAccessor = this.accessors[sampler.input];
        const outputAccessor = this.accessors[sampler.output];
        let i = 0;
        for (i = 0; i < inputAccessor.count; i++) {
            const nt = inputAccessor.getByIndex(i)[0];
            if (nt > t) {
                return this._complementFrame(t, inputAccessor.getByIndex(i - 1), inputAccessor.getByIndex(i), outputAccessor.getByIndex(i - 1), outputAccessor.getByIndex(i), sampler.interpolation);
            }
        }
        return this._complementFrame(t, inputAccessor.getByIndex(i - 1), null, outputAccessor.getByIndex(i - 1), null, sampler.interpolation);
    }
    _complementFrame(t, t1, t2, v1, v2, interpolation) {
        if (!v1) {
            return v2;
        }
        if (!v2) {
            return v1;
        }
        const delta = ((t - t1[0]) / (t2[0] - t1[0])); // TODO interpolator?
        return Interpolators[interpolation](delta, v1, v2);
    }
}



// WEBPACK FOOTER //
// ./src/Animation/Animation.ts